import React from 'react';
import { CallSimulator } from '../../components/CallSimulator/CallSimulator';
import useLocalization from '../../localization/useLocalization';
import { useAppSelector } from '../../store/hooks';
import { getAuthToken } from '../../store/selectors/auth';
import type { RootState } from '../../store/types';

function CallSimulatorContainer() {
    const localization = useLocalization();
    const jwtToken = useAppSelector((state: RootState) => getAuthToken(state) || '');

    return <CallSimulator jwtToken={jwtToken} localization={localization} />;
}

export default CallSimulatorContainer;
